import React, { useContext, useRef } from 'react';
import { murmurhash } from '../../../../../lib/js/hash';
import Form from '../../../../molecules/Form';
import { BlockInteractionContext } from '../../BlockInteractionContext';
import { RefreshBlockContext } from '../../../../../_lib/BlockFetcher/RefreshBlockContext';
import IForm from '../../../../../types/IForm';
import { RefreshCallback } from '../../../../../_lib/FetchContainer';
import { CloseSecondaryView } from '../../BlockInteractionsTypes';
import { SubmitOrCancelFormTemplate } from './SubmitOrCancelFormTemplate';

type SubmitOrCancelFormType = {
  form: IForm;
  headline: string;
  transnamespaceAndKey: string;
  cancelAction: CloseSecondaryView;
  validateResponseStatus: () => void;
  refreshBlock: RefreshCallback;
};

export function SubmitOrCancelForm({
  form,
  headline,
  cancelAction,
  transnamespaceAndKey,
  validateResponseStatus,
  refreshBlock,
}: SubmitOrCancelFormType) {
  const headlineId = useRef(murmurhash(form.url));

  const refreshContext = useContext(RefreshBlockContext);
  const blockInteractionContext = useContext(BlockInteractionContext);

  // legacy compatible refresh function used for blocks who implement blockinteractions from different blockfetchers
  // new asFetchableBlock have access to these contexts
  // old BlockFetcher()() components do not, so we used the passed refreshblock functions
  // config upload in portal settings is neither new nor old blockfetcher, special case
  const legacyCompatibleRefresh = () => {
    if (refreshBlock) {
      setTimeout(() => {
        refreshBlock();
      }, 1500);
    } else if (refreshContext && blockInteractionContext) {
      setTimeout(() => {
        refreshContext.refresh?.();
        blockInteractionContext.switchToDefaultView?.();
      }, 1000);
    }
  };

  return (
    <Form
      id="submit-or-cancel-form"
      model={form}
      ariaLabelledby={headlineId.current}
      onSuccess={legacyCompatibleRefresh}
      validateResponseStatus={validateResponseStatus}
    >
      <SubmitOrCancelFormTemplate
        cancelAction={cancelAction}
        headline={headline}
        headlineId={headlineId.current}
        transnamespaceAndKey={transnamespaceAndKey}
      />
    </Form>
  );
}
